import React, { Component } from 'react';
import {Button, Form, Input, List, Popover, Select, Checkbox, DatePicker, Upload, message, Spin} from "antd";
import {InfoCircleOutlined, MinusCircleOutlined, PlusOutlined, UploadOutlined} from "@ant-design/icons";
import EligibleLateDelivery from "./components/eligibleLateDelivery";
import PricingError from "./components/pricingError";
import ServiceSoftwareCancellation from "./components/serviceSoftwareCancellation";
import BoxDamage from "./components/boxDamage";
import DeadOnArrival from "./components/deadOnArrival";
import ProductDamage from "./components/productDamage";
import Other from "./components/other";
import CBSOMaintenanceContracts from "./components/CBSOMaintenanceContracts";
import PriceProtectionDispute from "./components/priceProtectionDispute";
import Model from "./model/model";
import DifferentClaimDetails from "./differentCustomer/differentClaimDetails";
import PPNoCreditNumber from "../wepcg/PPNoCreditNumber";
import MassModel from "../wepcg/model/massModel";
import {mass_upload} from "../../../requist";

const { TextArea } = Input;
const { Option } = Select;

const formItemLayoutWithOutLabel = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8,offset:2 },
    },
    wrapperCol: {
        xs: { span: 20 },
        sm: { span: 10 },
    },
};
const downLoadFiles={
    "other":'assets/downLoadFile/Dispute_mass_upload_template-all_invoice_claimed-Only-Other.xlsx',
    "pp":'assets/downLoadFile/Dispute_mass_upload_template-all_invoice_claimed-Only-PP.xlsx',
    "LostUnits":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-Lost_Units.xlsx',
    "BoxDamage":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-Box_Damage.xlsx',
    "FaultyOptionsUnderWarranty":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-Faulty_Option_Under_Warranty.xlsx',
    "ProductDamage":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-Product_Damage.xlsx',
    "PricingErrorTheWhole":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-Pricing.xlsx',
    "ServiceSoftwareCancellationTheWhole":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-Service_and_Software_Cancellation.xlsx',
    "OtherTheWhole":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-Return_Request_Other.xlsx',
    "ppTheWhole":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-PP.xlsx',
    "CBSO":'assets/downLoadFile/Dispute_mass_upload_template-all_invoice_claimed-Only-CBSO.xlsx',
    "CBSOTheWhole":'assets/downLoadFile/Dispute_mass_upload_template-partial_invoice_claimed-CBSO.xlsx',
}
class ClaimDetails extends Component{
    constructor(props) {
        super(props);
        this.optionList=[
            {value:'Incompatible order',key:'INCOR'},
            {value:'Machine returned / DOA',key:'MRDOA'},
            {value:'Not delivered',key:'NOTDE'},
            {value:'Software (SUSE / REDHAT / XCLARITY / VMWARE)',key:'SOFTW'},
            {value:'Wrong amount ordered',key:'WRAOR'},
            {value:'Other',key:'OTHER'},
        ]
        this.currencyList=[
            {value:'CHF',key:'CHF'},
            {value:'DKK',key:'DKK'},
            {value:'EUR',key:'EUR'},
            {value:'GBP',key:'GBP'},
            {value:'ILS',key:'ILS'},
            {value:'NOK',key:'NOK'},
            {value:'SEK',key:'SEK'},
            {value:'USD',key:'USD'},
        ]
        this.state={
            full_invoice_Claim_Checked: false,
            the_whole_invoice_claim: false,
            the_no_credit_number_claim:false,
            fileList:[],
            epackTypeKey:0,
            MassModelVisible:false,
            MassModelData:[],
            loading:false
        }
        this.οnKeyPress=(e)=>{
            e.preventDefault();
            let keyCode = null;
            if(e.which)
                keyCode = e.which;
            else if(e.keyCode)
                keyCode = e.keyCode;
            if(keyCode === 13) {
                if(this.state.the_whole_invoice_claim || this.props.type==1 || this.props.type==4){
                    this.props.getInvoiceClaim()
                }else{
                    this.props.ModalVisible()
                }
                return false;
            }
        }
    }
    fileMassProps(){
        let that = this
        return {
            name: 'file',
            maxCount:1,
            beforeUpload(file,fileList){
                // console.log(fileList[0])
                return false
            },
            onChange(info) {
                if (info.file.status !== 'uploading') {
                    // console.log(info.file, info.fileList);
                    that.setState({loading:true})
                    let data = new FormData();
                    data.append('file',info.file)
                    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
                    const {full_invoice_Claim_Checked,the_whole_invoice_claim}=that.state;
                    let flag;
                    if(that.props.type===14 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                        that.props.type===13 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                        that.props.type===3 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                        that.props.type===11 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                        that.props.type===5 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                        that.props.type===2 && full_invoice_Claim_Checked ||
                        that.props.type===10 && full_invoice_Claim_Checked
                    ){
                        flag = 'P'
                    }else if(that.props.type===14 && the_whole_invoice_claim ||
                        that.props.type===13 && the_whole_invoice_claim ||
                        that.props.type===3 && the_whole_invoice_claim ||
                        that.props.type===11 && the_whole_invoice_claim ||
                        that.props.type===5 && the_whole_invoice_claim ||
                        that.props.type===1 && full_invoice_Claim_Checked ||
                        that.props.type===4 && full_invoice_Claim_Checked
                    ){
                        flag='F'
                    }
                    const params = {
                        disputeType:that.props.disputeType,
                        region:'WE',
                        businessUnit:'D',
                        isPartnerHubUser:userInfo.source==='external',
                        templateFlag:flag
                    }
                    mass_upload(data,params).then(res=>{
                        const {data,retCode,retMsg} = res;
                        if(retCode==="200"){
                            that.setState({MassModelVisible:true,MassModelData:data,loading:false})
                        }else{
                            message.warn(`${retMsg}`)
                            that.setState({loading:false})
                        }
                    })
                }
                if (info.file.status === 'done') {
                    message.success(`${info.file.name} file uploaded successfully`);

                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };
    }
    MassOK=()=>{
        this.setState({MassModelVisible:false})
    }
    MassCancel=()=>{
        this.setState({MassModelVisible:false})
    }
    onChange=(e)=> {
        console.log(`checked = ${e.target.checked}`);
    }
    FullinvoiceClaimChecked=(e)=>{
        if(this.props.type==13){
            this.props.PPMass(e.target.checked)
        }
        this.setState({full_invoice_Claim_Checked:e.target.checked})
    }
    TheWholeInvoiceClaim=(e)=>{
        this.setState({the_whole_invoice_claim:e.target.checked})
    }
    TheNoCreditNumberClaim=(e)=>{
        this.setState({the_no_credit_number_claim:e.target.checked})
    }
    componentWillReceiveProps(nextProps){
        if (nextProps.type !== this.props.type){
            // console.log('type更新')
            if(this.props.type===13){
                this.setState({the_whole_invoice_claim:false})
            }else{
                this.setState({full_invoice_Claim_Checked:false,the_whole_invoice_claim:false})
            }
        }
    }
    handleCancel = () => {
        this.setState({isModalVisible:false,selectedRowKeys: []})
    };
    EpackType = (key) =>{
        if(key=="INCOR"){
            this.setState({epackTypeKey:1})
        }else if(key=="MRDOA"){
            this.setState({epackTypeKey:2})
        }else if(key=="NOTDE"){
            this.setState({epackTypeKey:3})
        }else if(key=="SOFTW"){
            this.setState({epackTypeKey:4})
        }else if(key=="WRAOR"){
            this.setState({epackTypeKey:5})
        }else if(key=="OTHER"){
            this.setState({epackTypeKey:5})
        }
    }
    checkeDownLoadUrl(){
        const {the_whole_invoice_claim}=this.state;
        if(the_whole_invoice_claim){
            if(this.props.type===14){
                return downLoadFiles.CBSOTheWhole
            }else if(this.props.type===3){
                return downLoadFiles.PricingErrorTheWhole
            }else if(this.props.type===5){
                return downLoadFiles.ServiceSoftwareCancellationTheWhole
            }else if(this.props.type===11){
                return downLoadFiles.OtherTheWhole
            }else if(this.props.type===13){
                return downLoadFiles.ppTheWhole
            }
        }else{
            if(this.props.type===14){
                return downLoadFiles.CBSO
            }else if(this.props.type===1 
                || this.props.type===3 
                || this.props.type===4 
                || this.props.type===5 
                || this.props.type===11
               ){
                   return downLoadFiles.other
               }else if(this.props.type===6){
                    return downLoadFiles.BoxDamage
                }else if(this.props.type==10){
                    return downLoadFiles.ProductDamage
                }else if(this.props.type===8){
                    return downLoadFiles.FaultyOptionsUnderWarranty
                }else if(this.props.type===13){
                    return downLoadFiles.pp
                }
        }
    }

    render() {
        const {MassModelData,full_invoice_Claim_Checked,the_whole_invoice_claim,the_no_credit_number_claim,epackTypeKey} = this.state
        return <div>
            <div className="example" style={{display:this.state.loading?'block':'none'}}>
                <Spin spinning={this.state.loading} />
            </div>
            <Model
                {...this.props}
                selectedRowKeys={this.props.selectedRowKeys}
                dataChecked={this.props.dataChecked}
                ModalVisible={this.props.isModalVisible}
                handleOk={this.props.callback}
                handleCancel={this.props.handleCancel}
                invoice_number={this.props.invoice_number}
            />
            {this.state.MassModelVisible ?
                <MassModel
                    {...this.props}
                    handleOk={this.MassOK}
                    onCancel={this.MassCancel}
                    data={MassModelData}
                    flag={'WED'}
                    full_invoice_Claim_Checked={full_invoice_Claim_Checked}
                    the_whole_invoice_claim={the_whole_invoice_claim}
                    ModalVisible={this.state.MassModelVisible}/>
                :
                ''}
            {this.props.type==5?
                <div>
                    <Form.Item
                        label="Epack Type"
                        name={'epackType'}
                        rules={[{ required: true }]}
                    >
                        <Select placeholder={'Please select'} onChange={this.EpackType}>
                            {
                                this.optionList.map((item)=>{
                                    return <Option value={item.key} >{item.value}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Claim Description"
                        name={'ClaimDescription'}
                        rules={[{ required: true }]}
                    >
                        <TextArea maxLength={255} />
                    </Form.Item>
                </div>:''
            }
            {this.props.type==1?''
                // <Form.Item
                //     label="Mass Upload"
                //     rules={[{ required: false}]}
                //     name={"MassUpload"}
                //     valuePropName={'checked'}
                // >
                //     <Checkbox onChange={this.FullinvoiceClaimChecked}><strong>Full invoice claim</strong></Checkbox>
                // </Form.Item>
                :''
            }
            {this.props.type==5 || this.props.type==7 || this.props.type==11 || this.props.type==14?''
                // <Form.Item
                //     label="Mass Upload"
                //     rules={[{ required: false}]}
                //     name={"MassUpload"}
                //     valuePropName={'checked'}
                // >
                //     <Checkbox onChange={this.FullinvoiceClaimChecked}></Checkbox>
                // </Form.Item>
                :''
            }
            {this.props.type==6 || this.props.type==10?''
                // <Form.Item
                //     label="Mass Upload"
                //     rules={[{ required: false}]}
                //     name={"MassUpload"}
                //     valuePropName={'checked'}
                // >
                //     <Checkbox onChange={this.FullinvoiceClaimChecked}><strong>Partial invoice claim</strong></Checkbox>
                // </Form.Item>
                :''
            }
            {this.props.type==3 || this.props.type==13?
                <div>
                    {/*<Form.Item*/}
                    {/*    label="Mass Upload"*/}
                    {/*    rules={[{ required: false}]}*/}
                    {/*    name={"MassUpload"}*/}
                    {/*    valuePropName={'checked'}*/}
                    {/*>*/}
                    {/*    <Checkbox onChange={this.FullinvoiceClaimChecked} ></Checkbox>*/}
                    {/*</Form.Item>*/}
                    {/*<Form.Item*/}
                    {/*    label={this.props.type==13?'The whole credit dispute':'The whole invoice claim'}*/}
                    {/*    rules={[{ required: false}]}*/}
                    {/*>*/}
                    {/*    <Checkbox onChange={this.TheWholeInvoiceClaim}></Checkbox>*/}
                    {/*</Form.Item>*/}
                    {this.props.type==13?
                        <Form.Item
                            label="No Credit number to dispute"
                            rules={[{ required: false}]}
                            name={"No Credit number to dispute"}
                        >
                            <Checkbox onChange={this.TheNoCreditNumberClaim}></Checkbox>
                        </Form.Item>:''
                    }
                </div>:''
            }
            {this.props.type==5 || this.props.type==7 || this.props.type==11 || this.props.type==14?''
                // <Form.Item
                //     label="The whole invoice claim"
                //     rules={[{ required: false}]}
                // >
                //     <Checkbox onChange={this.TheWholeInvoiceClaim}></Checkbox>
                // </Form.Item>
                :''
            }
            {this.props.type==2?
                <div className="spaceBox spaceHeaderBox">
                    {/*<Form.Item*/}
                    {/*    label="Mass Upload"*/}
                    {/*    rules={[{ required: false}]}*/}
                    {/*    name={"MassUpload"}*/}
                    {/*    valuePropName={'checked'}*/}
                    {/*>*/}
                    {/*    <Checkbox onChange={this.FullinvoiceClaimChecked}><strong>Partial invoice claim</strong></Checkbox>*/}
                    {/*</Form.Item>*/}
                    {full_invoice_Claim_Checked?
                        <div>
                            <Form.Item
                                className={'addFormBtn'}
                                label="Claim Details"
                            >
                            </Form.Item>
                            <Form.Item
                                label={ <a href={downLoadFiles.LostUnits} download={downLoadFiles.LostUnits} style={{color:'#dc291e'}}>Mass Invoice Upload</a> }
                                name="Mass Invoice Upload"
                                rules={[{ required: true }]}
                            >
                                <Upload {...this.fileMassProps()}>
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                </Upload>
                            </Form.Item>
                            <p style={{color:'#dc291e',marginLeft: '42%'}}>Please click 'Mass invoice Upload' field to download mass upload template</p>
                        </div>
                        :
                        <div>
                            <Form.List name="template1">
                                {(fields, { add, remove }) => (
                                    <>
                                        <Form.Item
                                            className={'addFormBtn'}
                                            label="Claim Details"
                                        >
                                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                            </Button>
                                        </Form.Item>
                                        {fields.sort(function (a, b) {
                                            return b.name - a.name;
                                        }).map(({ key, name, fieldKey, field, index, ...restField }) => (
                                            <div key={key} className="spaceBox">
                                                {this.props.InvoiceClaimMsg?
                                                    <Form.Item
                                                        {...formItemLayoutWithOutLabel}
                                                        label="Invoice Number"
                                                        {...restField}
                                                        name={[name,'invoiceNumber']}
                                                        fieldKey={[fieldKey, 'invoiceNumber']}
                                                        rules={[{ required: true }]}
                                                    >
                                                        <Input maxLength={10} />
                                                        <MinusCircleOutlined onClick={() => {
                                                            remove(name)
                                                            this.props.deleteData(name)
                                                        }}/>
                                                    </Form.Item>
                                                    :
                                                    <Form.Item
                                                        {...formItemLayoutWithOutLabel}
                                                        label="Invoice Number"
                                                        {...restField}
                                                        name={[name,'invoiceNumber']}
                                                        fieldKey={[fieldKey, 'invoiceNumber']}
                                                        rules={[{ required: true }]}
                                                    >
                                                        <Input maxLength={10} fieldKey={name} onPressEnter={this.οnKeyPress} suffix={<Popover>
                                                            <Button type="primary" onClick={this.props.ModalVisible}>Validate</Button>
                                                            <MinusCircleOutlined onClick={() => {
                                                                remove(name)
                                                                this.props.deleteData(name)
                                                            }}/>
                                                        </Popover>}/>
                                                    </Form.Item>
                                                }
                                                {this.props.InvoiceClaimMsg?
                                                    <Form.Item
                                                        label="Invoice Item Number"
                                                        {...restField}
                                                        name={[name, 'invoiceItemNo']}
                                                        fieldKey={[fieldKey, 'invoiceItemNo']}
                                                        rules={[{ required: false }]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    :
                                                    <div>
                                                        <Form.Item
                                                            label="Sold To"
                                                            {...restField}
                                                            name={[name, 'soldToNumber']}
                                                            fieldKey={[fieldKey, 'soldToNumber']}
                                                            rules={[{ required: true }]}
                                                        >
                                                            <Input disabled />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Delivery Number"
                                                            {...restField}
                                                            name={[name, 'deliveryNumber']}
                                                            fieldKey={[fieldKey, 'deliveryNumber']}
                                                            rules={[{ required: true}]}
                                                        >
                                                            <Input disabled />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Case ID"
                                                            {...restField}
                                                            name={[name, 'caseId']}
                                                            fieldKey={[fieldKey, 'caseId']}
                                                            rules={[{ required: false}]}
                                                        >
                                                            <Input maxLength={20} />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="PO Number"
                                                            {...restField}
                                                            name={[name, 'poNumber']}
                                                            fieldKey={[fieldKey, 'poNumber']}
                                                            rules={[{ required: true}]}
                                                        >
                                                            <Input disabled />
                                                        </Form.Item>
                                                    </div>
                                                }
                                                <Form.Item
                                                    label="Part Number"
                                                    {...restField}
                                                    name={[name, 'partNumber']}
                                                    fieldKey={[fieldKey, 'partNumber']}
                                                    rules={[{ required: true}]}
                                                >
                                                    <Input disabled={this.props.InvoiceClaimMsg?false:true} />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Quantity"
                                                    {...restField}
                                                    name={[name, 'quantity']}
                                                    fieldKey={[fieldKey, 'quantity']}
                                                    rules={[{ required: true}]}
                                                    onChange={(e)=>{
                                                        this.props.onCreditAmountTotal(e,name)
                                                    }}
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Serial Number"
                                                    {...restField}
                                                    name={[name, 'serialNumbers']}
                                                    fieldKey={[fieldKey, 'serialNumbers']}
                                                    rules={[{ required: true}]}
                                                    tooltip={{ title:
                                                            <ul>
                                                                <li>1) Serial Number is mandatory and input correctly SN;</li>
                                                                <li>2) the SN would be different and Serial Numbers should be separated by comma; </li>
                                                                <li>3) the number of SN should be equal to the PN qty; </li>
                                                            </ul>,
                                                        icon: <InfoCircleOutlined /> }}
                                                >
                                                    <TextArea />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Credit Amount Per Unit"
                                                    {...restField}
                                                    name={[name, 'creditAmountUnit']}
                                                    fieldKey={[fieldKey, 'creditAmountUnit']}
                                                    rules={[{ required: false}]}
                                                    onChange={(e)=>{
                                                        this.props.onCreditAmountTotal(e,name)
                                                    }}
                                                >
                                                    <Input />
                                                </Form.Item>
                                                {this.props.InvoiceClaimMsg?'':
                                                    <Form.Item
                                                        label="Credit Amount Total"
                                                        {...restField}
                                                        name={[name, 'creditAmountTotal']}
                                                        fieldKey={[fieldKey, 'creditAmountTotal']}
                                                        rules={[{ required: false}]}
                                                    >
                                                        <Input disabled />
                                                    </Form.Item>
                                                }
                                                <Form.Item
                                                    label="Currency"
                                                    {...restField}
                                                    name={[name, 'currency']}
                                                    fieldKey={[fieldKey, 'currency']}
                                                    rules={[{ required: true}]}
                                                >
                                                    <Select placeholder={'Please select'}>
                                                        {
                                                            this.currencyList.map((item)=>{
                                                                return <Option value={item.key} >{item.value}</Option>
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>

                                            </div>
                                        ))}
                                    </>
                                )}
                            </Form.List>
                            <Form.Item
                                label="Invoice Number"
                                name={'invoiceNumber'}
                                rules={[{ required: true }]}
                            >
                                {this.props.InvoiceClaimMsg?
                                    <Input maxLength={10} />
                                    :
                                    <Input maxLength={10} onPressEnter={this.οnKeyPress} suffix={
                                        <span>
                                            <Button type="primary" onClick={this.props.ModalVisible}>Validate</Button>
                                            <MinusCircleOutlined onClick={this.props.deleteFirstData}/>
                                        </span>
                                    }/>
                                }
                            </Form.Item>
                            {this.props.InvoiceClaimMsg?
                                <Form.Item
                                    label="Invoice Item Number"
                                    name={'invoiceItemNo'}
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>:''
                            }
                            {this.props.InvoiceClaimMsg?'':
                                <div>
                                    <Form.Item
                                        label="Sold To"
                                        name={'soldToNumber'}
                                        rules={[{ required: true }]}
                                    >
                                        <Input disabled />
                                    </Form.Item>
                                    <Form.Item
                                        label="Delivery Number"
                                        name={'deliveryNumber'}
                                        rules={[{ required: true }]}
                                    >
                                        <Input disabled />
                                    </Form.Item>
                                    <Form.Item
                                        label="Case ID"
                                        name={'caseId'}
                                        rules={[{ required: false }]}
                                    >
                                        <Input maxLength={20} />
                                    </Form.Item>
                                    <Form.Item
                                        label="PO Number"
                                        name={'poNumber'}
                                        rules={[{ required: true }]}
                                    >
                                        <Input disabled />
                                    </Form.Item>
                                </div>
                            }
                            <Form.Item
                                label="Part Number"
                                name={'partNumber'}
                                rules={[{ required: true }]}
                            >
                                <Input disabled={this.props.InvoiceClaimMsg?false:true} />
                            </Form.Item>
                            <Form.Item
                                label="Quantity"
                                name={'quantity'}
                                rules={[{ required: true }]}
                            >
                                <Input onChange={this.props.onCreditAmountTotal} />
                            </Form.Item>
                            <Form.Item
                                label="Serial Number"
                                name={'serialNumbers'}
                                rules={[{ required: true}]}
                                tooltip={{ title:
                                            <ul>
                                                <li>1) Serial Number is mandatory and input correctly SN;</li>
                                                <li>2) the SN would be different and Serial Numbers should be separated by comma; </li>
                                                <li>3) the number of SN should be equal to the PN qty; </li>
                                            </ul>,
                                    icon: <InfoCircleOutlined /> }}
                            >
                                <TextArea />
                            </Form.Item>
                            <Form.Item
                                label="Credit Amount Per Unit"
                                name={'creditAmountUnit'}
                                rules={[{ required: false }]}
                            >
                                <Input onChange={this.props.onCreditAmountTotal}  />
                            </Form.Item>
                            {this.props.InvoiceClaimMsg?'':
                                <Form.Item
                                    label="Credit Amount Total"
                                    name={'creditAmountTotal'}
                                    rules={[{ required: false }]}
                                >
                                    <Input disabled />
                                </Form.Item>
                            }
                            <Form.Item
                                label="Currency"
                                name={'currency'}
                                rules={[{ required: true }]}
                            >
                                <Select placeholder={'Please select'}>
                                    {
                                        this.currencyList.map((item)=>{
                                            return <Option value={item.key} >{item.value}</Option>
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </div>
                    }
                </div>
                :this.props.type==4?
                    <div>
                        <Form.Item
                            label="Mass Upload"
                            rules={[{ required: false}]}
                            name={"MassUpload"}
                            valuePropName={'checked'}
                        >
                            <Checkbox onChange={this.FullinvoiceClaimChecked}>
                                {/*<strong>Full invoice claim</strong>*/}
                            </Checkbox>
                        </Form.Item>
                        <div className="spaceBox spaceHeaderBox">
                            {full_invoice_Claim_Checked?
                                <div>
                                    <Form.Item
                                        className={'addFormBtn'}
                                        label="Claim Details"
                                    >
                                    </Form.Item>
                                    <Form.Item
                                        label={ <a href={downLoadFiles.other} download={'Mass_upload_invoice_dispute_rebill.xlsx'} style={{color:'#dc291e'}}>Mass Invoice Upload</a> }
                                        name="Mass Invoice Upload"
                                        rules={[{ required: true }]}
                                    >
                                        <Upload {...this.fileMassProps()}>
                                            <Button icon={<UploadOutlined />}>Upload</Button>
                                        </Upload>
                                    </Form.Item>
                                    <p style={{color:'#dc291e',marginLeft: '42%'}}>Please click 'Mass invoice Upload' field to download mass upload template</p>
                                </div>
                                :
                                <div>
                                    <Form.List name="template1">
                                        {(fields, { add, remove }) => (
                                            <>
                                                <Form.Item
                                                    className={'addFormBtn'}
                                                    label="Claim Details"
                                                >
                                                    <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                                    </Button>
                                                </Form.Item>
                                                {fields.sort(function (a, b) {
                                                    return b.name - a.name;
                                                }).map(({ key, name, fieldKey, field, index, ...restField }) => (
                                                    <div key={key} className="spaceBox">
                                                        {this.props.InvoiceClaimMsg?
                                                            <div>
                                                                <Form.Item
                                                                    {...formItemLayoutWithOutLabel}
                                                                    label="Invoice Number"
                                                                    {...restField}
                                                                    name={[name,'invoiceNumber']}
                                                                    fieldKey={[fieldKey, 'invoiceNumber']}
                                                                    rules={[{ required: true }]}
                                                                >
                                                                    <Input maxLength={10} />
                                                                    <MinusCircleOutlined onClick={() => {
                                                                        remove(name)
                                                                        this.props.deleteData(name)
                                                                    }}/>
                                                                </Form.Item>
                                                                <Form.Item
                                                                    label="Invoice Item Number"
                                                                    {...restField}
                                                                    name={[name, 'invoiceItemNo']}
                                                                    fieldKey={[fieldKey, 'invoiceItemNo']}
                                                                    rules={[{ required: false }]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </div>
                                                            :
                                                            <div>
                                                                <Form.Item
                                                                    {...formItemLayoutWithOutLabel}
                                                                    label="Invoice Number"
                                                                    {...restField}
                                                                    name={[name,'invoiceNumber']}
                                                                    fieldKey={[fieldKey, 'invoiceNumber']}
                                                                    rules={[{ required: true }]}
                                                                >
                                                                    <Input maxLength={10} fieldKey={name} onPressEnter={this.οnKeyPress} suffix={<div>
                                                                        <Button type="primary" onClick={this.props.onRebillInvoice}>Validate</Button>
                                                                        <MinusCircleOutlined onClick={() => {
                                                                            remove(name)
                                                                            this.props.deleteData(name)
                                                                        }}/>
                                                                    </div>}/>
                                                                </Form.Item>
                                                                <Form.Item
                                                                    label="Sold To"
                                                                    {...restField}
                                                                    name={[name, 'soldToNumber']}
                                                                    fieldKey={[fieldKey, 'soldToNumber']}
                                                                    rules={[{ required: true }]}
                                                                >
                                                                    <Input disabled />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    label="PO Number"
                                                                    {...restField}
                                                                    name={[name, 'poNumber']}
                                                                    fieldKey={[fieldKey, 'poNumber']}
                                                                    rules={[{ required: true }]}
                                                                >
                                                                    <Input disabled />
                                                                </Form.Item>
                                                            </div>
                                                        }
                                                        <Form.Item
                                                            label="Currency"
                                                            {...restField}
                                                            name={[name, 'currency']}
                                                            fieldKey={[fieldKey, 'currency']}
                                                            rules={[{ required: true }]}
                                                        >
                                                            <Select placeholder={'Please select'}>
                                                                {
                                                                    this.currencyList.map((item)=>{
                                                                        return <Option value={item.key} >{item.value}</Option>
                                                                    })
                                                                }
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                    </Form.List>
                                    <Form.Item
                                        label="Invoice Number"
                                        name={'invoiceNumber'}
                                        rules={[{ required: true }]}
                                    >
                                        {this.props.InvoiceClaimMsg?
                                            <Input maxLength={10} />
                                            :
                                            <Input maxLength={10} onPressEnter={this.οnKeyPress} suffix={
                                                <span>
                                                    <Button type="primary" onClick={this.props.onRebillInvoice}>Validate</Button>
                                                    <MinusCircleOutlined onClick={this.props.deleteFirstData}/>
                                                </span>
                                            }
                                            />
                                        }
                                    </Form.Item>
                                    <p style={{color:'#dc291e',marginLeft:'42%',display:this.props.InvoiceClaimMsg?'block':'none'}}>The invoice number is linked to different customer</p>
                                    {this.props.InvoiceClaimMsg?
                                        <Form.Item
                                            label="Invoice Item Number"
                                            name={'invoiceItemNo'}
                                            rules={[{ required: false }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                        :
                                        <div>
                                            <Form.Item
                                                label="Sold To"
                                                name={'soldToNumber'}
                                                rules={[{ required: true }]}
                                            >
                                                <Input disabled />
                                            </Form.Item>
                                            <Form.Item
                                                label="PO Number"
                                                name={'poNumber'}
                                                rules={[{ required: true }]}
                                            >
                                                <Input disabled />
                                            </Form.Item>
                                        </div>
                                    }
                                    <Form.Item
                                        label="Currency"
                                        name={'currency'}
                                        rules={[{ required: true }]}
                                    >
                                        <Select placeholder={'Please select'}>
                                            {
                                                this.currencyList.map((item)=>{
                                                    return <Option value={item.key} >{item.value}</Option>
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            }
                        </div>
                    </div>:
                <div className="spaceBox spaceHeaderBox">
                    {full_invoice_Claim_Checked?
                        <div>
                            <Form.Item
                                className={'addFormBtn'}
                                label="Claim Details"
                            >
                            </Form.Item>
                            <Form.Item
                                label={ <a href={this.checkeDownLoadUrl()} download={this.checkeDownLoadUrl()} style={{color:'#dc291e'}}>{this.props.type==13?'Mass Credit Upload':'Mass Invoice Upload'}</a> }
                                name="Mass Invoice Upload"
                                rules={[{ required: true }]}
                            >
                                <Upload {...this.fileMassProps()}>
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                </Upload>
                            </Form.Item>
                            <p style={{color:'#dc291e',marginLeft: '42%'}}>Please click 'Mass invoice Upload' field to download mass upload template</p>
                        </div>
                        :the_no_credit_number_claim?
                            <PPNoCreditNumber {...this.props} currencyList={this.currencyList} />
                            :
                        <div>
                            {this.props.type==1?
                                <EligibleLateDelivery {...this.props} οnKeyPress={this.οnKeyPress.bind(this)} currencyList={this.currencyList} />
                                :this.props.type==3?
                                    <PricingError {...this.props} οnKeyPress={this.οnKeyPress.bind(this)} currencyList={this.currencyList} />:
                                    this.props.type==5?
                                        <ServiceSoftwareCancellation {...this.props} οnKeyPress={this.οnKeyPress.bind(this)} currencyList={this.currencyList} epackTypeKey={this.state.epackTypeKey} />:
                                        this.props.type==6?
                                            <BoxDamage {...this.props} οnKeyPress={this.οnKeyPress.bind(this)} currencyList={this.currencyList} />:
                                            this.props.type==10?
                                                <ProductDamage {...this.props} οnKeyPress={this.οnKeyPress.bind(this)} currencyList={this.currencyList} />:
                                                this.props.type==11?
                                                    <Other {...this.props} οnKeyPress={this.οnKeyPress.bind(this)} currencyList={this.currencyList} />:
                                                    this.props.type==13?
                                                        <PriceProtectionDispute {...this.props} οnKeyPress={this.οnKeyPress.bind(this)} currencyList={this.currencyList} />:
                                                        this.props.type==14?
                                                            <CBSOMaintenanceContracts {...this.props} οnKeyPress={this.οnKeyPress.bind(this)} currencyList={this.currencyList} />:
                                                            ''
                            }
                            {this.props.InvoiceClaimMsg?
                                <DifferentClaimDetails {...this.props} epackTypeKey={epackTypeKey} currencyList={this.currencyList} />
                                :
                                <div>
                                    <Form.Item
                                        // label="Invoice Number"
                                        label={this.props.type==13?'Credit number':'Invoice Number'}
                                        name={'invoiceNumber'}
                                        rules={[{ required: true}]}
                                    >
                                        <Input maxLength={10} onPressEnter={this.οnKeyPress} suffix={
                                            the_whole_invoice_claim || this.props.type==1?
                                                <span>
                                                    <Button type="primary" onClick={this.props.getInvoiceClaim}>Validate</Button>
                                                    <MinusCircleOutlined onClick={this.props.deleteFirstData}/>
                                                </span>
                                                :
                                                <span>
                                                    <Button type="primary" onClick={this.props.ModalVisible}>Validate</Button>
                                                    <MinusCircleOutlined onClick={this.props.deleteFirstData}/>
                                                </span>
                                        }/>
                                    </Form.Item>
                                    <Form.Item
                                        label="Sold To"
                                        name={'soldToNumber'}
                                        rules={[{ required: true}]}
                                    >
                                        <Input disabled />
                                    </Form.Item>
                                    {this.props.type==5 && this.state.epackTypeKey==2?
                                        <Form.Item
                                            label="DOA Period Confirmation Number"
                                            name={'doaConfirmNo'}
                                            rules={[{ required: true}]}
                                        >
                                            <Input maxLength={10} />
                                        </Form.Item>:''
                                    }
                                    {this.props.type==3?
                                        <Form.Item
                                            label="Contract Number"
                                            name={'contractNumber'}
                                            rules={[{ required: false }]}
                                        >
                                            <Input maxLength={10} />
                                        </Form.Item>:''
                                    }
                                    <Form.Item
                                        label="PO Number"
                                        name={'poNumber'}
                                        rules={[{ required: true }]}
                                    >
                                        <Input disabled={this.props.type==14?false:true} />
                                    </Form.Item>
                                    {this.props.type == 5 || this.props.type == 14 || this.props.type == 13 ?'':
                                        <Form.Item
                                            label="Delivery Number"
                                            name={'deliveryNumber'}
                                            rules={[{ required: true}]}
                                        >
                                            <Input disabled />
                                        </Form.Item>
                                    }
                                    {this.props.type == 5 || this.props.type == 13 || this.props.type == 14 ? '' :
                                        <Form.Item
                                            label="Order Number"
                                            name={'orderNumber'}
                                            rules={[{ required: true }]}
                                        >
                                            <Input disabled />
                                        </Form.Item>
                                    }
                                    {this.props.type == 14?'':
                                        <Form.Item
                                            label="Part Number"
                                            name={'partNumber'}
                                            rules={[{ required: true }]}
                                        >
                                            <Input disabled={this.props.type==10 || this.props.type==11?false:true} />
                                        </Form.Item>
                                    }
                                    <Form.Item
                                        label="Quantity"
                                        name={'quantity'}
                                        rules={[{ required: true }]}
                                    >
                                        <Input onChange={this.props.onCreditAmountTotal} />
                                    </Form.Item>
                                    {this.props.type==8 || this.props.type==5|| this.props.type==3 || this.props.type==13?'':
                                        <Form.Item
                                            label="Serial Number"
                                            name={'serialNumbers'}
                                            rules={[{ required: this.props.type==10 || this.props.type==6?true:false }]}
                                            tooltip={{ title:
                                                    this.props.type==10 || this.props.type==6?
                                                        <ul>
                                                            <li>1) Serial Number is mandatory and input correctly SN;</li>
                                                            <li>2) the SN would be different and Serial Numbers should be separated by comma; </li>
                                                            <li>3) the number of SN should be equal to the PN qty; </li>
                                                        </ul>:
                                                        <ul>
                                                            <li>1) Serial Number is option , pls input correctly SN if input Serial Number;</li>
                                                            <li>2) the SN would be different and Serial Numbers should be separated by comma; </li>
                                                            <li>3) the number of SN should be equal to the PN qty;</li>
                                                        </ul>,
                                                icon: <InfoCircleOutlined /> }}
                                        >
                                            <TextArea />
                                        </Form.Item>
                                    }
                                    {/*epackTypeKey判断逻辑*/}
                                    {/*{this.props.type==5 && this.state.epackTypeKey==1?*/}
                                    {/*    <Form.Item*/}
                                    {/*        label="Serial Number"*/}
                                    {/*        name={'serialNumbers'}*/}
                                    {/*        rules={[{ required:true }]}*/}
                                    {/*        tooltip={{ title:*/}
                                    {/*                    <ul>*/}
                                    {/*                        <li>1) Serial Number is mandatory and input correctly SN;</li>*/}
                                    {/*                        <li>2) the SN would be different and Serial Numbers should be separated by comma; </li>*/}
                                    {/*                        <li>3) the number of SN should be equal to the PN qty; </li>*/}
                                    {/*                    </ul>,*/}
                                    {/*            icon: <InfoCircleOutlined /> }}*/}
                                    {/*    >*/}
                                    {/*        <TextArea />*/}
                                    {/*    </Form.Item>:''*/}
                                    {/*}*/}
                                    {this.props.type==6 || this.props.type==7 || this.props.type==8 || this.props.type==10 || this.props.type==11?
                                        <Form.Item
                                            label="BIOS Password"
                                            name={'biosPassword'}
                                            rules={[{ required: false }]}
                                        >
                                            <Input maxLength={20} />
                                        </Form.Item>:''
                                    }
                                    {this.props.type==13?
                                        <Form.Item
                                            label="Price Drop Date"
                                            name={'priceDropDate'}
                                            rules={[{ required: true}]}
                                        >
                                            <DatePicker />
                                        </Form.Item>:
                                        this.props.type==1?'':
                                        <Form.Item
                                            label="Credit Amount Per Unit"
                                            name={'creditAmountUnit'}
                                            rules={[{ required: this.props.type==11?true:false }]}
                                        >
                                            <Input onChange={this.props.onCreditAmountTotal}  />
                                        </Form.Item>
                                    }
                                    {this.props.type==13?
                                        <div>
                                            <Form.Item
                                                label="Unit Dispute Value"
                                                name={'creditAmountUnit'}
                                                rules={[{ required: true}]}
                                            >
                                                <Input onChange={this.props.onCreditAmountTotal} />
                                            </Form.Item>
                                            <Form.Item
                                                label="Dispute Value Total"
                                                name={'creditAmountTotal'}
                                                rules={[{ required: true}]}
                                            >
                                                <Input disabled />
                                            </Form.Item>
                                        </div>
                                        :
                                        <Form.Item
                                            label="Credit Amount Total"
                                            name={'creditAmountTotal'}
                                            rules={[{ required: this.props.type==11?true:false }]}
                                        >
                                            <Input disabled/>
                                        </Form.Item>
                                    }
                                    <Form.Item
                                        label="Currency"
                                        name={'currency'}
                                        rules={[{ required: this.props.type==1?false:true}]}
                                    >
                                        <Select placeholder={'Please select'}>
                                            {
                                                this.currencyList.map((item)=>{
                                                    return <Option value={item.key} >{item.value}</Option>
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                    {this.props.type==14?
                                        <Form.Item
                                            label="Contract Number"
                                            name={'contractNumber'}
                                            rules={[{ required: false}]}
                                        >
                                            <Input maxLength={10} />
                                        </Form.Item>:''
                                    }
                                    {this.props.type==14?
                                        <Form.Item
                                            label="Service Period Start Date"
                                            name={'serviceStartDate'}
                                            rules={[{ required: false}]}
                                        >
                                            <DatePicker />
                                        </Form.Item>:''
                                    }
                                    {this.props.type==14?
                                        <Form.Item
                                            label="Service Period End Date"
                                            name={'serviceEndDate'}
                                            rules={[{ required: false}]}
                                        >
                                            <DatePicker />
                                        </Form.Item>:''
                                    }
                                    {this.props.type==6 ?
                                        <Form.Item
                                            label="Also Product damaged"
                                            name={'productDamaged'}
                                            rules={[{ required: false }]}
                                            valuePropName={'checked'}
                                        >
                                            <Checkbox />
                                        </Form.Item> :''
                                    }
                                </div>
                            }

                        </div>
                    }

                </div>
            }
        </div>

    }

}

export default ClaimDetails;